import CheckIcon from '@mui/icons-material/Check';
import { Box, Stack, Tab } from "@mui/material";
import { ChangePassword } from 'Components/SettingsTs/Security/ChangePassword';
import { LoginInfo } from "Components/SettingsTs/Security/LoginInfo";
import TwoStepAuth from "Components/SettingsTs/Security/TwoStepAuth";
import { useAppSelector } from "helpers/hooks";
import { useState } from "react";
import { TabPanelProps } from 'shared/SharedModels';
import { ShTabs } from 'shared/SharedStyles/ShNavigation';

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index } = props;
    return (
        <Box role='tabpanel' minHeight={300} hidden={value !== index}>{value === index && (<>{children}</>)}</Box>
    );
}

export const Security = () => {
    const [tabValue, setTabValue] = useState<number>(0);
    const { emailVerification, securityVerification } = useAppSelector((state) => state.auth.auth);

    return (
        <>
            <Box maxWidth='600px'>
                <ShTabs aria-label="Security tabs" variant="scrollable" scrollButtons='auto'
                    allowScrollButtonsMobile value={tabValue} onChange={(evt, newValue) => setTabValue(newValue)}>
                    <Tab label='Change Password' />
                    <Tab label={<Stack flexDirection='row' alignItems='center'>
                        Two Step Verification {(emailVerification || securityVerification) &&
                            <CheckIcon className='check-icon' color='success' fontSize='small' />}
                    </Stack>} />
                    <Tab label='Last Login Info' />
                </ShTabs>
                <TabPanel value={tabValue} index={0}>
                    <ChangePassword />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <TwoStepAuth />
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                    <LoginInfo />
                </TabPanel>
            </Box>
        </>
    );
}
